import React from 'react';
//import { useEffect, useRef } from 'react'
import StatusContext from '../../../contexts/StatusContext'
import {PushButton} from '../pushbutton/PushButton'
import {MultilineText} from '../multilinetext/MultilineText';

import "./savechat.css"

export const SaveChat = ({label, text, disabled, onChange, onSave}) => {


  let {
    changeLanguage,
  } = React.useContext(StatusContext);

  
  return (
       
    <div className="navbartestButtons">
      
      <div style={{paddingTop:'30px'}}>
      <PushButton onClick={onSave} disablebutton = {disabled}   label =  {changeLanguage('aitest','save')}/>
      </div>

      <div style={{paddingLeft:'10px', width:'80%'}}>
        <label style = {{color: 'black',fontSize:'14px'}}> {label}</label>
        <br></br>
      <MultilineText text={text}  textcolor='black' backcolor='' onChange={onChange} />
    </div>
    </div>
  );
  

 
};

SaveChat.defaultProps = {
  disabled: false,

  rows: 4,
}
